/*
 * Keeps the mobile "buy box" (product__mobile-top) in sync with variant changes.
 *
 * The mobile variant picker shares the section's VariantSelects logic, which
 * updates the hidden desktop price (#price-{section}) and publishes
 * PUB_SUB_EVENTS.variantChange. The visible mobile price and the mobile add-to-cart
 * form aren't touched by that flow, so we mirror them here after each change.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data) return;
    var sectionId = data.sectionId;
    var html = data.html;
    var variant = data.variant;

    // Mirror the freshly-rendered price into the visible mobile price container.
    var mobilePrice = document.querySelector('.product__mobile-price');
    if (mobilePrice && html) {
      var source = html.getElementById('price-' + sectionId);
      if (source) mobilePrice.innerHTML = source.innerHTML;
    }

    // Point the mobile add-to-cart form at the selected variant + reflect availability.
    var mobileForm = document.getElementById('product-form-mobile-' + sectionId);
    if (mobileForm && variant) {
      var idInput = mobileForm.querySelector('input[name="id"], .product-variant-id');
      if (idInput) idInput.value = variant.id;

      var submit = mobileForm.querySelector('.product-form__submit');
      if (submit) {
        var label = submit.querySelector('span');
        var strings = window.variantStrings || {};
        if (variant.available) {
          submit.removeAttribute('disabled');
          if (label) label.textContent = strings.addToCart || 'Add to cart';
        } else {
          submit.setAttribute('disabled', 'disabled');
          if (label) label.textContent = strings.soldOut || 'Sold out';
        }
      }
    }
  });
})();
